import { Ghost } from 'lucide-react';
import { Badge, badgeVariants } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { Quote } from '@/types';
import { STATUS_LABELS, STATUS_VARIANT, dutchDate } from './quoteMeta';

export function QuoteStatusBadge({ quote, className }: { quote: Quote; className?: string }) {
  const variant = STATUS_VARIANT[quote.status] || 'secondary';
  /* De ondertekenvoortgang staat in QuoteSignatureStatus, niet nog eens hier. */
  const label = STATUS_LABELS[quote.status] || quote.status;
  if (quote.countersignUrl) {
    return (
      <a
        href={quote.countersignUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className={cn(
          badgeVariants({ variant }),
          'inline-flex cursor-pointer whitespace-nowrap no-underline hover:opacity-90',
          className,
        )}
      >
        {label}
      </a>
    );
  }
  return <Badge variant={variant} className={cn('whitespace-nowrap', className)}>{label}</Badge>;
}

/**
 * Concept dat na het aanmaken nooit is geopend of bewerkt. De backend leidt dit af
 * uit bestaande velden (status, viewCount, createdAt/updatedAt, blok-bewerkingen).
 */
export function GhostQuoteBadge({ quote, className }: { quote: Quote; className?: string }) {
  if (!quote.isGhost) return null;
  return (
    <Badge
      variant="outline"
      className={cn('gap-1 border-dashed text-muted-foreground', className)}
      title={`Aangemaakt op ${dutchDate(quote.createdAt)} en daarna nooit geopend of bewerkt`}
    >
      <Ghost className="h-3 w-3 shrink-0" />
      Spookofferte
    </Badge>
  );
}
